import { useState, useEffect } from 'react'
import { getErrors } from 'core/helpers'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { SystemInformationItemDto } from 'generated/v1/v1IntegrationsApi'
import { Row, Col, ListGroup, Badge } from 'react-bootstrap'
import { DefaultButton, MessageAlert, PageHeader, Spinner } from 'components'
import { AlertMessage, IPageProps, IRootState } from 'types'
import { AppDispatch } from 'state/store'
import { useDispatch, useSelector } from 'react-redux'
import { startLoadingAction, endLoadingAction } from 'state/actions/appActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SystemInformationPage = ({ title }: IPageProps) => {
    const dispatch = useDispatch<AppDispatch>()
    const loading = useSelector((state: IRootState) => state.app.loading)
    const [alert, setAlert] = useState<AlertMessage>()
    const [frontendItems, setFrontendItems] = useState<SystemInformationItemDto[]>([])
    const [backendItems, setBackendItems] = useState<SystemInformationItemDto[]>([])
    const [loaded, setLoaded] = useState(false)

    const fetch = async () => {
        try {
            dispatch(startLoadingAction())
            const response = await V1ApiIntegrationsClient.getSystemInformationForAllApps()
            setFrontendItems(response.frontendItems || [])
            setBackendItems(response.backendItems || [])
        } catch (e) {
            setAlert({ variant: 'danger', messages: getErrors(e) })
        }
        finally {
            setLoaded(true)
            dispatch(endLoadingAction())
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    if (!loaded) {
        return <Spinner center />
    }

    return (
        <Row>
            <PageHeader title={title}>
                <DefaultButton
                    variant='default me-2'
                    onClick={fetch}
                >
                    <FontAwesomeIcon icon={['fas', 'sync']} /> {' '} Refresh
                </DefaultButton>
            </PageHeader>
            <MessageAlert alert={alert} />

            <Col md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>

                <h2 className='text-center'>Production</h2>

                <ListGroup>
                    <ListGroup.Item>
                        <strong>FRONTEND</strong>
                    </ListGroup.Item>

                    {frontendItems.map((item, index) => (
                        <ListGroup.Item key={index} className='d-flex justify-content-between align-items-center'>
                            {item.appName}
                            {loading
                                ? <Spinner size='sm' />
                                : <Badge bg='primary' pill>
                                    {item.status}
                                </Badge>
                            }
                        </ListGroup.Item>
                    ))}
                </ListGroup>
                <hr />
                <ListGroup>
                    <ListGroup.Item>
                        <strong>BACKEND</strong>
                    </ListGroup.Item>

                    {backendItems.map((item, index) => (
                        <ListGroup.Item key={index} className='d-flex justify-content-between align-items-center'>
                            {item.appName}
                            {loading
                                ? <Spinner size='sm' />
                                : <Badge bg='primary' pill>
                                    {item.status}
                                </Badge>
                            }
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Col>
        </Row>
    )
}

export default SystemInformationPage